import React,{useContext} from 'react'
import uniqWith from "lodash/uniqWith"
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { PolicyUpdateListItem } from './PolicyUpdateListItem'
import { liabilityLimitPretty , KPretty} from '../../../../services/utils'
import { PolicyManagementContextStore } from '../../../../context/PolicyManagementContext';
import {PriceWithComma} from '../../../Core/PriceWithComma';
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService';


interface PolicyUpdateListProps {
    insurance: ActiveInsuranceModel,
}

export const PolicyUpdateList = ({insurance, ...props}: PolicyUpdateListProps) => {


    const policyManagementContext = useContext(PolicyManagementContextStore)
    const getAllAdditionalInsuredList = policyManagementContext.allAdditionalInsuredList
    const history = props.history
    const extnsions = !!history ? history.map((item,index)=>
           <PolicyUpdateListItem 
           key={`ex_${index}`} 
           changes={item.changes}
           title="Midterm" 
           downloadLinkText={'View Endorsement'} 
           downloadLink={item.pdf_url} 
           purchaseDate={item.effective_date} 
           startDate={item.effective_date} 
           endDate={insurance._insuranceEnd} 
           />):[]

  

    
    return ( <div className="history-list">  
                {insurance.policyStatus === 'Canceled' && 
                <PolicyUpdateListItem 
                  type="canceled"  
                  title={`Insurance canceled refund amount ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${insurance.cancelRefund}`}
                  startDate={insurance.cancelDateUtc} 
                  purchaseDate={insurance.cancelDateUtc} 
                  endDate={insurance.cancelDateUtc}
                />}   
                {extnsions}
                <PolicyUpdateListItem 
                  type="purchased" 
                  downloadLink={insurance.policyUrl}
                  title="Insurance purchased" 
                  startDate={insurance._insuranceStart} 
                  purchaseDate={insurance.dateAdded} 
                  downloadLinkText={'View Policy'}
                  endDate={insurance._insuranceEnd} />
            </div>
    )
}